// /**
//  * This source code is quoted from rc-util.
//  * homepage: https://github.com/react-component/util
//  */
// function createChainedFunction(...funcs) {
//   return funcs
//     .filter(f => f != null)
//     .reduce((acc, f) => {
//       if (typeof f !== 'function') {
//         throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
//       }
//
//       if (acc === null) {
//         return f;
//       }
//
//       return function chainedFunction(...args) {
//         acc.apply(this, args);
//         f.apply(this, args);
//       };
//     }, null);
// }
// export default createChainedFunction;
// 这个 createChainedFunction 函数的作用是把多个函数合并成一个新的函数，当你调用新函数时，所有原来的函数会依次被调用，并且参数和 this 都会被正确传递。
import createChainedFunction from 'rc-util/es/createChainedFunction';

export default createChainedFunction;
